if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.prevButton = this.querySelector('.slider-buttons button[name="previous"]')
      this.nextButton = this.querySelector('.slider-buttons button[name="next"]')
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
      
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }


    onButtonClick(event) {
      event.preventDefault()
      let button = event.target.closest('button')
      const activeMedia = this.elements.viewer.querySelector('.is-active');
      const mediaToSwitch = button.name === 'previous' ? activeMedia.previousElementSibling : activeMedia.nextElementSibling;
      if (!mediaToSwitch) return;
      this.setActiveMedia(mediaToSwitch.dataset.mediaId);
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaToSwitch.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    filterMediaByColor(color) {
      if (!this.elements.thumbnails) return;
      this.elements.thumbnails.querySelectorAll('li').forEach((element) => {
        let thumbColor = element.querySelector('img').alt.toLowerCase();
        if (thumbColor === color.toLowerCase()) {
          element.classList.remove('is-hidden');
        } else {
          element.classList.add('is-hidden');
        }
      });
      // Find the first thumbnail that is not hidden and matches the current variant's color
      const firstVisibleThumbnail = Array.from(this.elements.thumbnails.querySelectorAll('li'))
        .find(thumbnail => 
          !thumbnail.classList.contains('is-hidden') && 
          thumbnail.querySelector('img').alt.toLowerCase() === color.toLowerCase()
        );
      
      if (firstVisibleThumbnail) {
        this.setActiveMedia(firstVisibleThumbnail.dataset.target);
      } else {
        console.log(`No thumbnails available for the color ${color}.`);
      }

    }

    setActiveMedia(mediaId) {
      let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
    
      //If no media is found, select the first available media
      if (!activeMedia) {
        console.log(`Media with ID ${mediaId} not found. Falling back to the first available media.`);
        activeMedia = this.elements.viewer.querySelector('[data-media-id]');
      }
    this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
    activeMedia.classList.add('is-active');
    
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
    
      if (!this.elements.thumbnails) return;
      let activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      //If no thumbnail matches, select the first available thumbnail
      if (!activeThumbnail) {
        console.log(`Thumbnail for media ID ${mediaId} not found. Falling back to the first available thumbnail.`);
        activeThumbnail = this.elements.thumbnails.querySelector('li:not(.is-hidden)');
      }
    
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

// Function to filter media list items by color
function filterMediaByColor(color) {
  const mediaListItems = document.querySelectorAll('.product__media-list li');
  mediaListItems.forEach(item => {
    if (item.classList.contains(color.toLowerCase())) {
      item.classList.remove('is-hidden');
    }
    else if (item.querySelector('img').alt.toLowerCase() === color.toLowerCase()){
     item.classList.remove('is-hidden');
    }
    else {
      item.classList.add('is-hidden');
    }
  });
}

const isMobile = window.innerWidth < 768; // Check if viewport width is less than 768px
// Function to handle filtering when a radio button is clicked
function handleRadioClick(event) {
  const selectedColor = event.target.value;
  if (isMobile) {
    filterMediaByColor(selectedColor);
  }
}

// Attach event listeners to all radio inputs
const radioInputs = document.querySelectorAll('input[type="radio"][name="Color"]');
radioInputs.forEach(input => {
  input.addEventListener('click', handleRadioClick);
});

// Filter media list items onload
window.addEventListener('load', function() {
  let selectedColor = document.querySelector('input[type="radio"][name="Color"]:checked');
  if(selectedColor){
    selectedColor = selectedColor.value
  }
  if (isMobile) {
    filterMediaByColor(selectedColor);
  }
});